import React, { useState, useEffect } from 'react';
import SvgLogo from 'components/Svg/logo';
import SvgIconFacebook from 'components/Svg/iconfacebook';
import SvgIconTwitter from 'components/Svg/icontwitter';
import SvgIconYoutube from 'components/Svg/iconyoutube';
import SvgIconInstagram from 'components/Svg/iconinstagram';
import { environment, versionstr, social_links, app_links, footer_links } from 'config';
import imgIconLibro from 'assets/images/common/libro-de-reclamaciones.png';
//import imgIconReporte from 'assets/images/common/icon-report.png';
import { main_links } from 'config';
import SessionFactory from 'factories/Session';

const Footer = () => {

    const [screenWidth, setScreenWidth] = useState(0);
    const [classDropdown, setClassDropdown] = useState('');
    const [loadData, setLoadData] = useState(false);
    const [dataPage, setDataPage] = useState({});

    const openMenuMobile = (event) => {
        if(screenWidth < 992){
            setClassDropdown('container-dropdown-menu');
            const container_menu = event.target.parentElement;
            if(container_menu.className.includes('show-dropdown-menu'))
                container_menu.classList.remove('show-dropdown-menu');
            else
                container_menu.classList.add('show-dropdown-menu');
        }
    }
    useEffect(() => {
        setScreenWidth(window.screen.width);
    }, []);

    useEffect(() => {
        const sessValid = SessionFactory.validation()
        setDataPage({ session: sessValid });
        setLoadData(true);
    }, []);

    return (
        <>
        <footer className="newsletter">
            {/*
            <div className="container">
                <div className="row form">
                    <div className="col-12 col-md-6 d-flex align-items-center justify-content-center flex-column">
                        <h3>¡Suscríbete al newsletter y recibe ofertas!</h3>
                        <p className="d-none d-md-inline">He leido y acepto la <a href={app_links.politicas} target="_blank" rel="noreferrer">Política de Privacidad y Seguridad y la Política de Cookies</a></p>
                    </div>
                    <div className="col-12 col-md-6 d-flex">
                        <p><input type="email" name="textBoxNewsletterEmail" placeholder="Ingresa tu e-mail"/><button className="btn">Suscribir</button></p>
                    </div>
                    <div className="col-12 col-md-6 d-flex d-md-none">
                        <p className="legend">He leído y acepto la <a href={app_links.politicas} target="_blank" rel="noreferrer">Política de Privacidad y Seguriad y la Política de Cookies</a></p>
                    </div>
                </div>
            </div>
            */}
        </footer>
        <footer className="footer-menu">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="row">
                            <div className="col-5 col-lg-12">
                                <p className="text-center">
                                    <SvgLogo />
                                </p>
                            </div>
                            <div className="col-7 col-lg-12">
                                <p className="text-center txt-12 m-0 mt-1 mb-1 no-underline"><a href={app_links.call_center}>AYUDA CALLCENTER</a></p>
                                <p className="text-center no-underline"><a href={app_links.call_center}>(511) 613 8888</a></p>
                                <p className="text-center txt-12 mb-1">SÍGUENOS:</p>
                                <p className="text-center">
                                    <a href={social_links.facebook} target="_blank" rel="noreferrer" className="button-social-network"><SvgIconFacebook /></a>
                                    <a href={social_links.twitter} target="_blank" rel="noreferrer" className="button-social-network"><SvgIconTwitter /></a>
                                    <a href={social_links.youtube} target="_blank" rel="noreferrer" className="button-social-network"><SvgIconYoutube /></a>
                                    <a href={social_links.instagram} target="_blank" rel="noreferrer" className="button-social-network"><SvgIconInstagram /></a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-9">
                        <div className="row">
                            <div className={"col-12 col-lg-4 " + classDropdown}>
                                <h4 onClick={(event)=>openMenuMobile(event)}>NOSOTROS</h4>
                                <ul>
                                    <li><a href={footer_links.nosotros.bienvenido} target="_blank" rel="noreferrer">Bienvenidos a Metro</a></li>
                                    <li><a href={footer_links.nosotros.cencosud} target="_blank" rel="noreferrer">¿Qué es Cencosud?</a></li>
                                    <li><a href={footer_links.nosotros.memoria} target="_blank" rel="noreferrer">Memoria Cencosud</a></li>
                                
                                </ul>
                            </div>
                            <div className={"col-12 col-lg-4 " + classDropdown}>
                                <h4 onClick={(event)=>openMenuMobile(event)}>WEB DE CUPONES</h4>
                                <ul>
                                    {/* <li><a href={footer_links.tienda.beneficios} target="_blank" rel="noreferrer">Cómo Canjear</a></li>
                                    <li><a href={footer_links.tienda.pedidos} target="_blank" rel="noreferrer">Mis Cupones</a></li>
                                    <li><a href={footer_links.tienda.preguntas} target="_blank" rel="noreferrer">Preguntas Frecuentes</a></li> */}
                                    <li><a href={loadData && dataPage.session ? main_links.terms_cond :footer_links.tienda.terms_condition_public}  rel="noreferrer">Términos y Condiciones</a></li>
                                    <li><a href={loadData && dataPage.session ? main_links.privacy :footer_links.tienda.privacy_public}  rel="noreferrer">Politicas de Privacidad y Seguridad</a></li>
                                    <li><a href={loadData && dataPage.session ? main_links.data_protection : footer_links.tienda.data_protecction_public} rel="noreferrer">Protección de Datos </a></li>
                                    <li><a href={loadData && dataPage.session ? main_links.cookies: footer_links.tienda.cookies_public} rel="noreferrer">Políticas de cookies</a></li>
                                    <li><a href={footer_links.tienda.legales} target="_blank" rel="noreferrer">Legales</a></li>
                                    <li><a href={footer_links.tienda.covid} target="_blank" rel="noreferrer">Protocolos COVID</a></li>
                                    <li><a href={loadData && dataPage.session ? app_links.frequent_questions_private:app_links.frequent_questions}  rel="noreferrer">Preguntas Frecuentes</a></li> 
                                </ul>
                            </div>
                            <div className={"col-12 col-lg-4 " + classDropdown}>
                                <h4 onClick={(event)=>openMenuMobile(event)}>CONTÁCTANOS</h4>
                                <ul>
                                    <li><a href={footer_links.contacto.tiendas} target="_blank" rel="noreferrer">Nuestras Tiendas</a></li>
                                    <li><a href={footer_links.contacto.consultas} target="_blank" rel="noreferrer">Consultas y Sugerencias</a></li>
                                </ul>
                                <p className="text-center text-lg-left mt-5 libro-de-reclamaciones">
                                    <a href={app_links.libro_reclamaciones} target="_blank" rel="noreferrer"><img src={imgIconLibro}/></a>
                                </p>
                                {/* <p className="mt-4 d-flex justify-content-center justify-content-lg-start reporte-sostenibilidad no-underline">
                                    <a href={app_links.reporte_sostenibilidad} target="_blank" rel="noreferrer" className="mr-1">
                                        <img src={imgIconReporte}/>
                                    </a>
                                    <a href={app_links.reporte_sostenibilidad} target="_blank" rel="noreferrer" className="text-left">Reporte de<br/>Sostenibilidad 2022</a>
                                </p> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 credits">
                        {/* <p className="mb-1"><strong>COMPRAS 100% SEGURAS</strong></p>
                        <p className="m-0">Esta tienda está autorizada por Visa para realizar transacciones electrónicas.<br/>© 2022 Metro, Lima - Perú</p> */}
                        <p>© 2022 Metro, Lima - Perú</p> 
                        {versionstr!==''&&environment==='development'&&<div className="version-container">{versionstr}</div>}
                    </div>
                </div>
            </div>
        </footer>
        </>
    )
}

export default Footer;